import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import {createStore} from 'redux'
import allReducer from './reducers'
import { Provider } from 'react-redux'
import { unregister as unRegisterServiceWorker } from './serviceWorkerRegistration';

const ignoredResizeObserverErrors = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

const getResizeObserverMessage = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value?.message === 'string') return value.message;
  return String(value);
};

const shouldIgnoreResizeObserverError = (value) => {
  const message = getResizeObserverMessage(value);
  return ignoredResizeObserverErrors.some((ignoredMessage) => message.includes(ignoredMessage));
};

const hideResizeObserverOverlay = () => {
  const overlayIds = [
    'webpack-dev-server-client-overlay',
    'webpack-dev-server-client-overlay-div',
  ];

  overlayIds.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = 'none';
    }
  });
};

window.addEventListener('error', (event) => {
  if (shouldIgnoreResizeObserverError(event.message) || shouldIgnoreResizeObserverError(event.error)) {
    hideResizeObserverOverlay();
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (shouldIgnoreResizeObserverError(event.reason)) {
    hideResizeObserverOverlay();
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const originalConsoleError = console.error;
console.error = (...args) => {
  if (args.some((arg) => shouldIgnoreResizeObserverError(arg))) {
    hideResizeObserverOverlay();
    return;
  }

  originalConsoleError(...args);
};

// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() s an extension that allows us to see state changes in the browser
const store = createStore(allReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
// import reportWebVitals from './reportWebVitals';

// React Router 6.30 prints one future-flag warning per render until the app opts in, which buried
// the real console output of every manual check. Both flags are safe on this codebase as it stands:
// `v7_startTransition` is guarded by `React.startTransition` existing (6.30 does
// `const startTransitionImpl = React[START_TRANSITION]` and calls it only when it is defined), so on
// React 17 it falls back to exactly the synchronous state update used today; `v7_relativeSplatPath`
// only changes how paths resolve *inside* a splat route, and this route table has no `path="*"` at
// all — every route is an absolute literal. Opting in here means the warning-free state is what the
// browser sees too, instead of only `src/App.test.js`.
// `lms-subdomain` is already written by the time this runs: importing App above evaluates init.js.
// No theme step here any more: the app serves 1TVET only, so the campus colours are compiled into
// the stylesheets themselves (src/App.less @primary-color + the literals of the page skins).

ReactDOM.render(
   <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
     <Provider store={store}>
       <App />
     </Provider>
 </BrowserRouter>,
  document.getElementById('root')
);
unRegisterServiceWorker();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
